import { useEffect, useState } from 'react';

type Args = {
  id: string;
};

export function usePortal({ id }: Args) {
  const [ref] = useState<HTMLDivElement | null>(() =>
    typeof window === 'undefined' ? null : document.createElement('div')
  );

  useEffect(() => {
    if (ref) {
      ref.setAttribute('id', id);
      document.body.appendChild(ref);
      return () => {
        document.body.removeChild(ref);
      };
    }
  }, [id, ref]);

  return ref;
}
